   /* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useRef } from 'react';
import { Button } from 'primereact/button';
import { Fieldset } from 'primereact/fieldset';
import { InputText } from 'primereact/inputtext';
import { Dropdown } from 'primereact/dropdown';
import { TabView, TabPanel } from 'primereact/tabview';
import { Toast } from 'primereact/toast';
import { ConfirmDialog } from 'primereact/confirmdialog';
import { Controller, useForm } from 'react-hook-form';
import { classNames } from 'primereact/utils';
import { useNavigate } from 'react-router-dom';
import { LandingPageServe } from '../../services/api/LandingPageServ';
import { SftpServ } from '../../services/api/SftpServ';
import FileUploader from '../../components/FileUploader';
import EmbeddedFileExplorer from '../../components/EmbeddedFileExplorer';

const DOMAINS = [
  { label: 'knowledgeboats.com', value: 'knowledgeboats-com' },
  { label: 'knowledgeboats.info', value: 'knowledgeboats-info' },
  { label: 'hitech-articles.com', value: 'hitech-articles' },
];

const CreateExternalLP = () => {
  const navigate = useNavigate();
  const toast = useRef(null);
  const [activeTab, setActiveTab] = useState(0);
  const [viewUploader, setViewUploader] = useState(false);
  const [savedLP, setSavedLP] = useState(null);
  const [saving, setSaving] = useState(false);
const [pocId, setPocId] = useState(null);
  const defaultValues = {
    name: '',
    campaignId: '',
    campaignName: '',
    description: '',
    client: '',
    thumbnail: '',
    domain: 'knowledgeboats-com',
  };

  const { control, formState: { errors }, handleSubmit, setValue, watch } = useForm({ defaultValues });
  const selectedDomain = watch('domain');

  const getFormErrorMessage = (name) =>
    errors[name] ? <small className="p-error">{errors[name].message}</small> : <small className="p-error">&nbsp;</small>;

  const onSave = async (data) => {
    setSaving(true);
    try {
      const domainLabel = DOMAINS.find(d => d.value === data.domain)?.label || data.domain;
      const payload = {
        ...data,
        lpType: 'external',
        templateName: 'external',
        isWebinar: false,
        status: 'preapproval',
        hostingDetails: { domain: domainLabel, path: data.domain },
      };
      const res = await LandingPageServe.create(payload);
      setSavedLP(res);
setPocId(res._id);
      // create campaign folder on SFTP server: /<domain>/A<campaignId>
      try {
        await SftpServ.mkdir(`/${data.domain}/A${data.campaignId}`);
      } catch (err) {
        console.warn('SFTP folder creation failed:', err);
      }
      setSavedLP(res);
      toast.current.show({ severity: 'success', summary: 'Saved', detail: 'LP created successfully' });
      setActiveTab(1);
    } catch (err) {
      toast.current.show({ severity: 'error', summary: 'Error', detail: 'Creation failed' });
    } finally {
      setSaving(false);
    }
  };

  const handleCloseUploader = (data) => {
    if (data) setValue('thumbnail', data.Location, { shouldValidate: true });
    setViewUploader(false);
  };

  const SummaryForm = () => (
    <div className="grid pt-4">
      <div className="col-6 col-offset-3">
        <Fieldset legend="External LP Summary">
          <form>
            <div className="field">
              <Controller name="name" control={control} rules={{ required: 'Name is required.' }}
                render={({ field, fieldState }) => (
                  <>
                    <span className="p-float-label">
                      <InputText id={field.name} value={field.value} className={classNames({ 'p-invalid': fieldState.error })} onChange={e => field.onChange(e.target.value)} />
                      <label htmlFor={field.name}>Name</label>
                    </span>
                    {getFormErrorMessage(field.name)}
                  </>
                )}
              />
            </div>
            <div className="field">
              <Controller name="campaignId" control={control} rules={{ required: 'Campaign ID is required.' }}
                render={({ field, fieldState }) => (
                  <>
                    <span className="p-float-label">
                      <InputText id={field.name} value={field.value} className={classNames({ 'p-invalid': fieldState.error })} onChange={e => field.onChange(e.target.value)} />
                      <label htmlFor={field.name}>Campaign ID</label>
                    </span>
                    {getFormErrorMessage(field.name)}
                  </>
                )}
              />
            </div>
            <div className="field">
              <Controller name="description" control={control} rules={{ required: 'Description is required.' }}
                render={({ field, fieldState }) => (
                  <>
                    <span className="p-float-label">
                      <InputText id={field.name} value={field.value} className={classNames({ 'p-invalid': fieldState.error })} onChange={e => field.onChange(e.target.value)} />
                      <label htmlFor={field.name}>Description</label>
                    </span>
                    {getFormErrorMessage(field.name)}
                  </>
                )}
              />
            </div>
            <div className="field">
              <Controller name="client" control={control} rules={{ required: 'Client is required.' }}
                render={({ field, fieldState }) => (
                  <>
                    <span className="p-float-label">
                      <InputText id={field.name} value={field.value} className={classNames({ 'p-invalid': fieldState.error })} onChange={e => field.onChange(e.target.value)} />
                      <label htmlFor={field.name}>Client</label>
                    </span>
                    {getFormErrorMessage(field.name)}
                  </>
                )}
              />
            </div>
            <div className="field">
              <Controller name="domain" control={control} rules={{ required: 'Domain is required.' }}
                render={({ field, fieldState }) => (
                  <>
                    <label style={{ fontWeight: 600, marginBottom: '0.4rem', display: 'block', color: '#64748b', fontSize: '0.9rem' }}>Domain</label>
                    <Dropdown
                      id={field.name}
                      value={field.value}
                      options={DOMAINS}
                      onChange={e => field.onChange(e.value)}
                      placeholder="Select Domain"
                      className={classNames({ 'p-invalid': fieldState.error })}
                      style={{ width: '100%' }}
                    />
                    {getFormErrorMessage(field.name)}
                  </>
                )}
              />
            </div>
            <div className="field p-inputgroup pt-3">
              <Controller name="thumbnail" control={control} rules={{ required: 'Thumbnail is required.' }}
                render={({ field, fieldState }) => (
                  <>
                    <span className="p-float-label">
                      <InputText id={field.name} value={field.value} style={{ borderRadius: '5px' }} className={classNames({ 'p-invalid': fieldState.error })} onChange={e => field.onChange(e.target.value)} />
                      <label htmlFor={field.name}>Thumbnail</label>
                    </span>
                  </>
                )}
              />
              <Button label="Upload" icon="pi pi-cloud-upload" onClick={e => { e.preventDefault(); setViewUploader(true); }} />
            </div>
            {getFormErrorMessage('thumbnail')}
          </form>
        </Fieldset>
        <FileUploader open={viewUploader} handleCloseUploader={handleCloseUploader} />
      </div>
    </div>
  );

  return (
    <>
      <Toast ref={toast} />
      <ConfirmDialog />
      <div className="card">
        <div className="flex justify-content-between pb-1">
          <span style={{ fontWeight: 700, fontSize: '1.1rem', color: '#334155' }}>Create External LP</span>
          <div className="flex gap-3">
            <Button label="Cancel" severity="danger" size="small" outlined onClick={() => navigate('../lplist')} />
            {!savedLP && (
              <Button label="Next" severity="success" size="small" outlined loading={saving} onClick={handleSubmit(onSave)} />
            )}
            {savedLP && (
              <Button label="Save" severity="info" size="small" outlined onClick={() => navigate('../lplist')} />
            )}
          </div>
        </div>

        <TabView activeIndex={activeTab} onTabChange={e => setActiveTab(e.index)}>
          <TabPanel header="Summary">
            <SummaryForm />
          </TabPanel>
          <TabPanel header="Files" disabled={!savedLP}>
            {savedLP && (
              <EmbeddedFileExplorer
                domain={savedLP.hostingDetails?.path}
                domainLabel={savedLP.hostingDetails?.domain}
                campaignId={savedLP.campaignId}
                pocId={pocId}
              />
            )}
          </TabPanel>
        </TabView>
      </div>
    </>
  );
};

export default CreateExternalLP;
